module.exports = __webpack_public_path__ + "img/data-folder-svgrepo-com.33ba737d.svg";